// extracted by mini-css-extract-plugin
module.exports = {"cards":"style_cards__rRG_m","card":"style_card__NTdZ0","title":"style_title__po4q3"};